// Generated from b2bservices/src/common/productRequirements/evaluate.ts.
// Do not edit. Run yarn requirements:sync in a paired checkout.

import { baseProductRules } from './base';
import { productCategoryPath } from './categories';
import { PRODUCT_FIELD_RULES } from './rules';
import { REQUIRED_NUTRITIONAL_FIELDS, VITAMIN_MINERAL_FIELDS } from './validators';
import { EMPTY_PRODUCT_VALIDATIONS, MISSING_FIELD_ERROR } from './types';
import type { CategoryNode, ProductFieldRule, ProductRetailer, ProductValidations, ProductValues } from './types';

export type RequiredFieldsInput = {
  state?: ProductValues;
  rootCategory?: CategoryNode;
  categoryPath?: readonly string[];
  /** Taken from the authenticated account/product owner, never uploaded product fields. */
  retailers: readonly ProductRetailer[];
  producerIsStore: boolean;
  productInfoFilesCount?: number;
  imageCount?: number;
  applyRetailerRules: boolean;
  includeBase?: boolean;
  rules?: ProductFieldRule[];
};

export const evaluateRequiredFields = (input: RequiredFieldsInput): ProductValidations => {
  if (!input.state) return EMPTY_PRODUCT_VALIDATIONS;
  const state: ProductValues = { ...input.state, producerIsStore: input.producerIsStore };
  const categoryPath = input.categoryPath ?? productCategoryPath(state.foodlaCategory, input.rootCategory);
  const rules = [...(input.includeBase ? baseProductRules(state, input.rootCategory, categoryPath, input.imageCount) : []),
    ...(input.rules || PRODUCT_FIELD_RULES)];
  const result: ProductValidations = { requiredFields: {}, errors: [], missingFields: {} };
  for (const rule of rules) {
    const requiredBy = rule.organizations === 'base' ? [] : rule.organizations.filter(retailer => input.retailers.includes(retailer));
    if (rule.organizations !== 'base' && (!input.applyRetailerRules || !requiredBy.length)) continue;
    const fields = rule.fields.filter(field => !rule.categoryCondition || rule.categoryCondition({
      field, state, rootCategory: input.rootCategory, categoryPath,
    }));
    if (!fields.length) continue;
    for (const field of fields) if (!result.requiredFields[field]) result.requiredFields[field] = rule;
    const missing = fields.filter(field => rule.requireValidator && !rule.requireValidator({
      field, state, productInfoFilesCount: input.productInfoFilesCount,
    }));
    for (const field of missing) result.missingFields[field] = rule.message || MISSING_FIELD_ERROR;
    if (missing.length) result.errors.push({ field: missing[0], rule, requiredBy,
      message: rule.message || `${rule.label} är obligatoriskt` });
  }
  return result;
};

/** Read projection includes both required values and the fields that activate their conditions. */
export const REQUIREMENT_FIELD_NAMES = Array.from(new Set([
  ...REQUIRED_NUTRITIONAL_FIELDS, ...VITAMIN_MINERAL_FIELDS,
  ...PRODUCT_FIELD_RULES.flatMap(rule => rule.fields).filter(field => field !== 'vitamins_minerals'),
  'title', 'EAN', 'descriptive_size_amount', 'descriptive_size_unit', 'image_src', 'additionalImages',
  'non_food_ingredients', 'whiteSnusNicotinePerPortion', 'whiteSnusNicotinePerGram',
  'storePackOrderableUnit', 'storePackDespatchUnit', 'transportOrderableUnit', 'transportDespatchUnit',
  'palletOrderableUnit', 'palletDespatchUnit', 'signalWords', 'hazardSymbols', 'hazardStatements', 'securityNotices',
  'batteryType', 'other_substances', 'min_temperature', 'max_temperature', 'transportMinTemperature', 'transportMaxTemperature',
]));
